import { formatCreatedAt } from "./constants";

type StatusChangeCommentParams = {
  changedAt: string;
  actorName: string;
  statusLabel: string;
  reason: string;
};

export const formatStatusChangeComment = ({
  changedAt,
  actorName,
  statusLabel,
  reason,
}: StatusChangeCommentParams): string =>
  `${formatCreatedAt(changedAt)} - ${actorName} cambió el estado a ${statusLabel}.\n\nMotivo: ${reason.trim()}`;

export const appendStatusChangeComment = (
  currentComments: string,
  nextComment: string
): string => {
  const trimmedComments = currentComments.trim();

  if (!trimmedComments) {
    return nextComment;
  }

  return `${trimmedComments}\n\n${nextComment}`;
};
